import React, {useCallback} from "react";
import { SaveButton, Toolbar, useCreate, useUpdate, useRedirect, useNotify } from "react-admin";
import { useForm } from 'react-final-form';

const CustomSave = ({ handleSubmitWithRedirect, resource, ...props }) => {
    const [create] = useCreate(resource);
    const redirectTo = useRedirect();
    const notify = useNotify();
    const { basePath } = props;
    const form = useForm();

    const handleClick = useCallback(() => {
        const values = form.getState().values;
        const { confirmPassword, ...data } = values;
        create(
            {
                payload: { data },
            },
            {
                onSuccess: ({ data }) => {
                    if (data?.redirect_url) {
                        window.open(data.redirect_url, "_blank");
                    }
                    notify(data?.message ?? "Saved", 2000);
                    redirectTo(basePath);
                },
                onFailure: ({response: {data: {errors}}}) => {
                    if('message' in errors) {
                        notify(errors.message, { type: 'warning' });
                        return;
                    }
                    const message = errors[Object.keys(errors)[0]][0];
                    notify(message,{ type: 'warning' });
                },
            }
        );

    },[form]);

    return <SaveButton {...props} handleSubmitWithRedirect={handleClick} disabled={form.getState().hasValidationErrors} />;
};

const CustomEditSave = ({ resource, record, basePath, pristine, ...props }) => {
    const [update] = useUpdate(resource);
    const redirectTo = useRedirect();
    const notify = useNotify();
    const form = useForm();

    const handleClick = useCallback(() => {
        const values = form.getState().values;
        if (!record?.id) return;
        update(
            resource,
            record.id,
            values,
            record,
            {
                onSuccess: ({ data }) => {
                    if (data?.redirect_url) {
                        window.open(data.redirect_url, "_blank");
                    }
                    notify(data?.message ?? "Saved", 2000);
                    redirectTo(basePath);
                },
                onFailure: ({ response }) => {
                    const errors = response?.data?.errors ?? {};
                    if ('message' in errors) {
                        notify(errors.message, { type: 'warning' });
                        return;
                    }
                    const key = Object.keys(errors)[0];
                    const message = key && errors[key]?.[0] ? errors[key][0] : "An error occurred";
                    notify(message, { type: 'warning' });
                },
            }
        );
    }, [form, record, update, notify, redirectTo, basePath]);

    return (
        <SaveButton
            {...props}
            handleSubmitWithRedirect={handleClick}
            disabled={form.getState().hasValidationErrors || pristine}
        />
    );
};

const CreateToolbar = props => (
    <Toolbar {...props}>
        <CustomSave
            redirect="list"
            submitOnEnter={false}
            variant="text"
        />
    </Toolbar>
);

export { CustomEditSave };
export default CreateToolbar;